import { $confirm } from "../../../../../@custom_types/confirm";
import { Record } from "../../../../records/server/crud";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { orderBy } from "lodash";
import {
  ChangeJournalModalService,
  vsServiceName as ChangeJournalModalServiceName,
} from "../../../../records/changeJournal/changeNoteModalService";

export class AmendmentsViewController {
  static $inject = [
    "$confirm",
    ServerUtilityName,
    ChangeJournalModalServiceName,
  ];

  amendments!: Record[];
  amendmentId?: number;
  apiUrl!: string;
  title?: string;
  detailComponent!: string;

  constructor(
    private readonly $confirm: $confirm,
    private readonly serverUtility: ServerUtility,
    private readonly changeJournalModalService: ChangeJournalModalService
  ) {}

  $onInit(): void {
    this.amendments = orderBy(
      this.amendments,
      (a) => a.AmendmentDate,
      "desc"
    );
    this.amendments.forEach(
      (a) => (a.open = a.Id === this.amendmentId)
    );
  }

  delete(amendment: Record): void {
    this.$confirm({
      text: "Are you sure you want to delete this amendment?",
    })
      .then(() => this.changeJournalModalService.getChangeJournalNote())
      .then((note) =>
        this.serverUtility.delete({
          url: this.apiUrl,
          id: amendment.Id,
          params: { Note: note.Note },
        })
      )
      .then(() => {
        this.amendments = this.amendments.filter(
          (a) => a.Id !== amendment.Id
        );
      });
  }
}